const labels = {
    cs: {
      flash: "Kartičky",
      multiple: "Výběr z možností",
      timed: "Čtení na čas",
      title: "Hra Rychločtení",
      start: "Start",
      playAgain: "Hrát znovu",
      result: "Výsledek",
      correctRead: "Správně přečteno",
      amazing: "Skvělé!",
      good: "Dobrá hra",
      couldDoBetter: "Můžeš to zlepšit",
      tryAgain: "Zkus to znovu",
      durationLabel: "Zobrazit slovo na (sekundy)",
      word: "Slovo",
      of: "z",
      question: "Které to je?",
      score: "Skóre",
      next: "Další",
      remainingTime: "Zbývající čas",
      wordsRead: "Přečtená slova",
      finished: "Hotovo!",
      progressTitle: "Postup pro",
      filterByGame: "Filtrovat podle hry",
      filterByMode: "Filtrovat podle režimu",
      allForGame: "Vše pro {game}",
      noResults: "Zatím žádné výsledky.",
      scoreTrendTitle: "Vývoj skóre pro",
      backToGame: "Zpět do hry",
      whoIsPlaying: "Kdo dnes hraje?",
      selectExistingProfile: "Vyber existující profil:",
      deleteProfile: "Smazat profil",
      selectLanguage: "Vyber jazyk:",
      enterName: "Zadej jméno",
      chooseAvatar: "Vyber avatar:",
      orUploadAvatar: "Nebo nahraj obrázek:",
      preview: "Náhled:",
      letsGo: "Jdeme na to!",
      allCategories: "Všechny kategorie",
      newGame: "Nová hra",
      changeCategory: "Změnit kategorii",
      switchProfile: "Změnit profil",
      viewProgress: "Zobrazit postup",
      removePhoto: "Odebrat fotku",
      viewResults: "Zobrazit výsledky",
      chooseDifficulty: "Vyber obtížnost:",
      difficultyEasy: "Lehká",
      difficultyMedium: "Střední",
      difficultyHard: "Těžká",
      notEnoughWords: "Pro ostatní úrovně zatím nemáme dost slov.",
      noWords: "Pro tuto kategorii nejsou k dispozici žádná slova.",
      math: "Matematika",
      multiplication: "Násobení",
      division: "Dělení",
      plusminus: "Sčítání/Odčítání",
      tripleplusminus: "Trojité sčítání/odčítání",
      chooseNumber: "Vyber číslo:",
      chooseGameMode: "Vyber režim:",
      guessMode: "Hádej (3 možnosti)",
      aloneMode: "Sám (napiš odpověď)",
      pickCorrectAnswer: "Vyber správnou odpověď:",
      confirm: "Potvrdit",
      correct: "Správně!",
      wrong: "Špatně!",
      listening: "Poslech",
      listenToStory: "Poslechni si příběh. Kvíz se zobrazí po přehrání.",
      story1Title: "Děti ve škole",
      story2Title: "Minecraft",
      story3Title: "Miminko",
      story4Title: "Až budeme velcí",
      story5Title: "Velký piknik v parku",
      story6Title: "Nový domácí mazlíček",
      story7Title: "Překvapení pro babičku",
      backToStories: "Zpět na příběhy"
    },
    bg: {
      flash: "Карти",
      multiple: "Избери отговор",
      timed: "Четене с време",
      title: "Игра за бързо четене",
      start: "Старт",
      playAgain: "Играй отново",
      result: "Резултат",
      correctRead: "Правилно прочетени",
      amazing: "Страхотно!",
      good: "Добра игра",
      couldDoBetter: "Може и по-добре",
      tryAgain: "Опитай пак",
      durationLabel: "Показване на дума за (секунди)",
      word: "Дума",
      of: "от",
      question: "Кое е това?",
      score: "Точки",
      next: "Следващо",
      remainingTime: "Оставащо време",
      wordsRead: "Прочетени думи",
      finished: "Готово!",
      progressTitle: "Напредък за",
      filterByGame: "Филтрирай по игра",
      filterByMode: "Филтрирай по режим",
      allForGame: "Всички за {game}",
      noResults: "Все още няма резултати.",
      scoreTrendTitle: "Резултати за",
      backToGame: "Обратно в играта",
      whoIsPlaying: "Кой ще играе днес?",
      selectExistingProfile: "Избери съществуващ профил:",
      deleteProfile: "Изтрий профила",
      selectLanguage: "Избери език:",
      enterName: "Въведи име",
      chooseAvatar: "Избери аватар:",
      orUploadAvatar: "Или качи изображение:",
      preview: "Преглед:",
      letsGo: "Да започваме!",
      allCategories: "Всички категории",
      newGame: "Нова игра",
      changeCategory: "Смени категорията",
      switchProfile: "Смени профил",
      viewProgress: "Виж напредъка",
      removePhoto: "Премахни снимката",
      viewResults: "Виж резултатите",
      chooseDifficulty: "Избери трудност:",
      difficultyEasy: "Лесно",
      difficultyMedium: "Средно",
      difficultyHard: "Трудно",
      notEnoughWords: "Все още нямаме достатъчно думи за другите нива.",
      noWords: "Няма налични думи за тази категория.",
      math: "Математика",
      multiplication: "Умножение",
      division: "Деление",
      plusminus: "Събиране/Изваждане",
      tripleplusminus: "Тройно събиране/изваждане",
      chooseNumber: "Избери число:",
      chooseGameMode: "Избери режим:",
      guessMode: "Познай (3 възможности)",
      aloneMode: "Сам (въведи отговор)",
      pickCorrectAnswer: "Избери правилния отговор:",
      confirm: "Потвърди",
      correct: "Вярно!",
      wrong: "Грешно!",
      listening: "Слушане",
      listenToStory: "Чуй историята. Тестът ще се появи след края на аудиото.",
      story1Title: "Децата в училище",
      story2Title: "Майнкрафт",
      story3Title: "Бебе",
      story4Title: "Когато пораснем",
      story5Title: "Голямото пикник приключение",
      story6Title: "Новият домашен любимец",
      story7Title: "Изненадата за баба",
      backToStories: "Обратно към историите"
    },
    de: {
      flash: "Blitzkarten",
      multiple: "Mehrfachauswahl",
      timed: "Zeitlesen",
      title: "Blitz-Lesespiel",
      start: "Start",
      playAgain: "Nochmal spielen",
      result: "Ergebnis",
      correctRead: "Richtig gelesen",
      amazing: "Fantastisch!",
      good: "Gutes Spiel",
      couldDoBetter: "Du kannst es besser",
      tryAgain: "Versuch es nochmal",
      durationLabel: "Wort anzeigen für (Sekunden)",
      word: "Wort",
      of: "von",
      question: "Welches ist es?",
      score: "Punktzahl",
      next: "Weiter",
      remainingTime: "Verbleibende Zeit",
      wordsRead: "Gelesene Wörter",
      finished: "Fertig!",
      progressTitle: "Fortschritt für",
      filterByGame: "Nach Spiel filtern",
      filterByMode: "Nach Modus filtern",
      allForGame: "Alle für {game}",
      noResults: "Noch keine Ergebnisse.",
      scoreTrendTitle: "Punkteverlauf für",
      backToGame: "Zurück zum Spiel",
      whoIsPlaying: "Wer spielt heute?",
      selectExistingProfile: "Vorhandenes Profil wählen:",
      deleteProfile: "Profil löschen",
      selectLanguage: "Sprache wählen:",
      enterName: "Name eingeben",
      chooseAvatar: "Wähle einen Avatar:",
      orUploadAvatar: "Oder lade ein Bild hoch:",
      preview: "Vorschau:",
      letsGo: "Los geht's!",
      allCategories: "Alle Kategorien",
      newGame: "Neues Spiel",
      changeCategory: "Kategorie wechseln",
      switchProfile: "Profil wechseln",
      viewProgress: "Fortschritt anzeigen",
      removePhoto: "Foto entfernen",
      viewResults: "Ergebnisse anzeigen",
      chooseDifficulty: "Schwierigkeitsgrad wählen:",
      difficultyEasy: "Leicht",
      difficultyMedium: "Mittel",
      difficultyHard: "Schwer",
      notEnoughWords: "Für die anderen Schwierigkeitsgrade haben wir noch nicht genug Wörter.",
      noWords: "Für diese Kategorie sind keine Wörter verfügbar.",
      math: "Mathe",
      multiplication: "Multiplikation",
      division: "Division",
      plusminus: "Plus/Minus",
      tripleplusminus: "Dreifach Plus/Minus",
      chooseNumber: "Wähle eine Zahl:",
      chooseGameMode: "Wähle den Modus:",
      guessMode: "Raten (3 Möglichkeiten)",
      aloneMode: "Allein (Antwort tippen)",
      pickCorrectAnswer: "Wähle die richtige Antwort:",
      confirm: "Bestätigen",
      correct: "Richtig!",
      wrong: "Falsch!",
      listening: "Hören",
      listenToStory: "Höre dir die Geschichte an. Das Quiz erscheint nach der Wiedergabe.",
      story1Title: "Kinder in der Schule",
      story2Title: "Minecraft",
      story3Title: "Baby",
      story4Title: "Wenn wir groß sind",
      story5Title: "Das große Picknick",
      story6Title: "Das neue Haustier",
      story7Title: "Überraschung für Oma",
      backToStories: "Zurück zu den Geschichten"
    },
  };
  
  export default labels;